import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AppsContainer from '@tenant/core/AppsContainer';
import AppsHeader from '@tenant/core/AppsContainer/AppsHeader';
import useGoBack from '@tenant/utility/hooks/useGoBack';
import { ROUTE_STRING } from 'constants/RouteString';
import PipelineRunStatusView from './components/Common/PipelineRunStatusView';

// AC-13..AC-17 — single-run live status view. Polling + terminal-stop + teardown + 404
// handling all live inside PipelineRunStatusView (usePollPipelineRun). This is the routed
// shell for RUN_VIEW (/pipelines/:id/runs/:runId). Gated PIPELINE_READ in ./index.js.
const RunDetail = () => {
  const { id, runId } = useParams();
  const goBack = useGoBack();

  return (
    <AppsContainer
      fullView
      title={
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography color='text.primary'>Deployment</Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.PIPELINE.LIST}>Pipelines</Link>
          </Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.PIPELINE.RUNS.replace(':id', id)}>Runs</Link>
          </Typography>
          <Typography color='text.primary'>Status</Typography>
        </Breadcrumbs>
      }
    >
      <AppsHeader>
        <Box display='flex' alignItems='center' gap={4} sx={{ width: '100%' }}>
          {/* A run is reachable from the run history AND straight from the wizard's
              "run triggered" hand-off, so back returns to whichever it was; the run
              history is only the fallback for a deep-linked run. */}
          <ArrowBackIcon
            sx={{ color: 'text.secondary', cursor: 'pointer' }}
            onClick={() => goBack(ROUTE_STRING.PIPELINE.RUNS.replace(':id', id))}
          />
          <Typography variant='h4'>Run status</Typography>
        </Box>
      </AppsHeader>

      <Box p={4}>
        <PipelineRunStatusView pipelineId={id} runId={runId} />
      </Box>
    </AppsContainer>
  );
};

export default React.memo(RunDetail);
